import { Dialog } from '@headlessui/react'

import RubbishIcon from '@Icons/rubbish-icon-red.svg?react'
import XIcon from '@Icons/x-close-filter.svg?react'
import {
  useDeleteProductDispatch,
  useDeleteProductState,
} from '@Utils/context/modal/useDeleteProduct'

export default function DeleteProductModal(): JSX.Element {
  const { close, deleteProduct } = useDeleteProductDispatch()
  const { product } = useDeleteProductState()

  const onSubmit = () => {
    if (product) {
      deleteProduct({
        body: {
          select_all: false,
          selected_rows: [product.id],
          unselected_rows: [],
        },
      }).then(() => close())
    }
  }

  return (
    <div
      className="fixed inset-0 flex items-center justify-center p-4"
      style={{
        background: 'rgba(41, 41, 41, 0.7)',
        backdropFilter: 'blur(8px)',
      }}
    >
      <Dialog.Panel className="relative border rounded-xl shadow-xl bg-white-100 sm:w-2/3 md:w-1/2 lg:w-1/3 xl:w-1/4 w-full">
        <div className="flex flex-col p-6 items-center">
          <RubbishIcon />
          <button className="absolute right-8" onClick={close}>
            <XIcon />
          </button>
          <h1 className="font-medium text-lg text-gray-900 mt-5">
            Delete Product
          </h1>
          <p className="font-normal text-sm text-gray-500 mt-2 text-center">
            Are you sure you want to delete {product?.name}? This action cannot
            be undone.
          </p>
          <div className="flex flex-row mt-8 w-full">
            <button
              className="border border-solid border-gray-300 shadow-sm rounded-lg h-11 w-1/2 mr-1.5"
              onClick={close}
            >
              <span className="font-medium text-base text-gray-700 ">
                Cancel
              </span>
            </button>
            <button
              onClick={onSubmit}
              className="border border-solid border-error-600 bg-error-600 shadow-sm rounded-lg h-11 w-1/2 ml-1.5"
            >
              <span className="font-medium text-base text-white-100 ">
                Delete
              </span>
            </button>
          </div>
        </div>
      </Dialog.Panel>
    </div>
  )
}
